import $ from 'jquery';
import Cookie from "../../../utils/Cookie";

// Const
var SELECTOR_BTN = ".js-sobot-btn";
var COOKIE_PROFILE= "profilTiers";

// Classs can be intiated by search.js passing keyword

export default class Sobot {

    constructor(keyword) { 
        this.keyword = (keyword === undefined) ? "" : keyword;
        this.$btn = $(SELECTOR_BTN);
    }

	// Same as checkProfil() in search.js
	// Returns if profil is ok
	checkProfil() {
		
		// return ok if no profils desactivated
		var profilsToDeactivate = window.cmsGlobals.chatbotConfig.profilToDeactivate;
		if ( profilsToDeactivate && profilsToDeactivate != "") {} else return true;
		
		// return ok if not connected (no profile)
		var profilT = Cookie.getByName(COOKIE_PROFILE);
		if (profilT === "") return true;
		
		// Profile desactived ?
		var listOfProfiles = profilsToDeactivate.split(',');
		var profileOk = true;
		listOfProfiles.forEach(function(profilToDeactivate){
			if (profilT.includes(profilToDeactivate)) 
				profileOk = false;
		});
		return profileOk;
	}

    initSobot() {
        var _self = this;

		// Check conditions :	
		// - Globally disabled ?
        if (window.cmsGlobals.chatbotConfig.disabled) return true;
		// - Interact api loaded ?
        if ((typeof sdcInteract == "undefined") || (typeof  sdcInteract.api == "undefined")) return true;
		// - Interact checkbox activated ?
		if (!document.getElementById('sticky_showContact')) return true;
		// - Chatbot checkbox activated ?
 		if (document.getElementById('chatbot_activated')==null) return true;
		// - Profil ?
		if (!_self.checkProfil()) return true;
			
		// Load Sobot Api (déplacé en interact.js)
		//$.getScript("/icd/static/pch-front/public/pch-lanceur.js", function(data, textStatus, jqxhr){ var result = jqxhr.status; }); 
		// -> charge : /icd/static/pch-front-js/3.0.11-V3-RC3/awtPchBuilder.js

		// Sobot panel, il semblerait que ce script est initié justement par .js-sobot
		var $container = $(".js-sobot"); if ($container) {} else return true;
		
		// Button sobot
		// - Click
		_self.$btn.on('click' , function() {
			// sdcInteract.api.openFeatureStickyPanel({feature: sdcInteract.api.constants.FEATURES.CHATBOT, keyWord: _self.keyword } );
			window.pchApi.startChat({keyword: _self.keyword });
		});
		// - Label 
		if (window.cmsGlobals.chatbotConfig.ctaSearchLabel) 
			_self.$btn.text(window.cmsGlobals.chatbotConfig.ctaSearchLabel);
		
		// Show Sobot panel
		$container.removeClass("dcw_visually-hidden");	

		// Interact chatbot feature, encore utile ?
		sdcInteract.api.getFeatureDisplayStatus(sdcInteract.api.constants.FEATURES.CHATBOT, _self.displaySobot);
	
    }

    // displayStatus.ngim : état de désactivation, encore utile, maintenant que le profile est géré ici ?
    displaySobot(displayStatus) { if ((displayStatus !== null) && (!displayStatus.ngim)) {  } }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/search/sobot.js